"use strict";
exports.__esModule = true;
var js_1 = require("@ledgerhq/coin-polkadot/bridge/js");
var deviceAccess_1 = require("../../../hw/deviceAccess");
exports["default"] = {
    currencyBridge: (0, js_1.buildCurrencyBridge)(deviceAccess_1.withDevice),
    accountBridge: (0, js_1.buildAccountBridge)(deviceAccess_1.withDevice)
};
//# sourceMappingURL=js.js.map